

/**
 *@fileoverview 遮罩层
 *@author zhenn
 */

define(function (require, exports, module) {
    var Layer = require('c-layer');
    var Mask = Layer.extend({

        defaults: {
            hideWhenTap: 1,
            css: {
                position: 'fixed',
                width: '100%',
                height: '100%',
                zIndex: 99,
                background: '#000',
                opacity: '0.8',
                top: 0,
                left: 0
            }
        },

        initialize: function initialize() {
            this.Parent.apply(this, arguments);
        },

        create: function create() {

            var self = this;
            self.Parent.apply(this, arguments);

            var el = self.get('el');

            el.css(self.get('css'));
            self.setPos();
            self.bindEvent();
        },

        bindEvent: function bindEvent() {
            var self = this;
            var el = this.get('el');
            var hideWhenTap = self.get('hideWhenTap');
            el.on('click', function () {
                if (!hideWhenTap) {
                    return;
                }
                self.destroy();
            });
        },

        setPos: function setPos() {
            var self = this;
            var el = self.get('el');

            var realHeight = document.body.offsetHeight;
            var viewportHeight = document.documentElement.clientHeight;
            var maskHeight = realHeight >= viewportHeight ? realHeight : viewportHeight;

            el.css('height', maskHeight);
        }

    });

    module.exports = Mask;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-mask/dist/index.js
// module id = 718
// module chunks = 0